import { reportsOptions } from 'constants/reports';

export const defaultInitialState = {
  name: null,
  status: reportsOptions[0],
  createdAtFrom: null,
  createdAtTo: null,
};
